import { useEffect } from "react";

// 404 PELADO del modo demo: se muestra cuando la dirección no trae la ruta secreta.
// A propósito no lleva marca, ni logotipo, ni enlace, ni aviso: no debe insinuar que
// exista una demostración detrás. Es el mismo cuerpo que devuelve un servidor estático.
export function NoEncontrado() {
  useEffect(() => {
    document.title = "404 Not Found";
  }, []);

  return (
    <div
      data-testid="demo-404"
      style={{
        margin: 0,
        padding: "2rem 1rem",
        background: "#fff",
        color: "#000",
        fontFamily: "'Times New Roman', Times, serif",
      }}
    >
      <h1 style={{ fontSize: "2em", fontWeight: "bold", margin: "0 0 0.4em" }}>404 Not Found</h1>
      <p style={{ margin: 0 }}>The requested URL was not found on this server.</p>
    </div>
  );
}

export default NoEncontrado;
